/**
 * Search component.
 * @module components/theme/Search/Search
 * - removed <div className="tileFooter"> from the page
 * - translated searchResultsTitle
 * - Helmet title translated
 * - read correct data from search state (total and batching)
 * - used siteSearchContent instead of searchContent action from @plone/volto
 * - added search input and search by type
 */

import Search from '@package/components/Search/Search';

export default Search;
